export default __webpack_public_path__ + "static/media/Beastmaster's Icon of Faith.027087ef.jpg";